import { Chart, ChartData, ChartOptions } from 'chart.js'
import _ from 'lodash'
import { Doughnut } from 'react-chartjs-2'
import ChartsHelper from './ChartsHelper'
import { useRef } from 'react'
import Helper from '../../helpers/Helper'

interface Props {
    data: ChartData<'doughnut', number[], unknown>
    options?: ChartOptions<'doughnut'>
    isLoading?: boolean
    onClickSerie?: (options: { seriesName: string, index: number }) => void
}

const DonutChart = ({ data, options, isLoading, onClickSerie }: Props) => {
    let chartData = data
    const chartOptions = options ?? {}

    const chartRef = useRef<Chart<'doughnut', number[], unknown>>(null)

    const handleChartHover = (event: any, activeElements: Array<any>) => {
        const canvas = chartRef.current?.canvas

        if (activeElements.length > 0 && Helper.hasVal(onClickSerie)) {
            canvas.style.cursor = 'pointer'
        } else {
            canvas.style.cursor = 'default'
        }
    }

    const handleChartClick = (event: React.MouseEvent<HTMLCanvasElement>) => {
        const myChart = chartRef.current
        const elements = myChart.getElementsAtEventForMode(event.nativeEvent, 'nearest', { intersect: true }, true)

        if (Helper.hasVal(elements) && elements.length > 0) {
            const datasetIndex = elements[0].datasetIndex
            const dataIndex = elements[0].index

            if (onClickSerie)
                onClickSerie({ index: dataIndex, seriesName: data.labels[datasetIndex] as string })
        }
    }

    if (isLoading) {
        chartData = {
            datasets: [
                { data: Array(3).fill(0).map(() => {
                    return Math.random() * 11
                }) }
            ],
            labels: Array(3).fill(0).map(() => '')
        }

        if (!chartOptions.plugins) chartOptions.plugins = DonutChartDefaultOptions.plugins
        if (!chartOptions.plugins.datalabels) chartOptions.plugins.datalabels = DonutChartDefaultOptions.plugins.datalabels
        chartOptions.plugins.legend.display = false
        chartOptions.plugins.datalabels.display = false
    } else {
        if (!chartOptions.plugins) chartOptions.plugins = DonutChartDefaultOptions.plugins
        if (!chartOptions.plugins.datalabels) chartOptions.plugins.datalabels = DonutChartDefaultOptions.plugins.datalabels
        chartOptions.plugins.legend.display = true
        chartOptions.plugins.datalabels.display = true
    }

    ChartsHelper.applyColorsToPieChart(chartData.datasets, isLoading)
    ChartsHelper.applyMode(chartOptions as any)

    const myOptions = chartOptions ?? DonutChartDefaultOptions

    return (
        <div style={{ height: '100%', width: '100%', position: 'relative' }}>
            <Doughnut
                ref={chartRef}
                data={chartData}
                width='100%'
                height='100%'
                options={{
                    ...myOptions,
                    onHover: (event, activeElements) => handleChartHover(event.native, activeElements)
                }}
                onClick={handleChartClick}
            />
        </div>
    )
}

export default DonutChart
export const DonutChartDefaultOptions: ChartOptions<'doughnut'> = {
    maintainAspectRatio: false,
    plugins: {
        tooltip: {
            enabled: true,
            callbacks: {
                label: context => {
                    const total = _.sum(context.dataset.data)
                    const selectedData = context.parsed
                    const percent = (100 * selectedData) / total

                    return context.label + ': ' + context.raw + ' (' + _.round(percent, 2) + '%)'
                }
            }
        },
        datalabels: {
            display: true,
            formatter: (value, context) => {
                const total = _.sum(context.dataset.data)
                const selectedData = value
                const percent = (100 * selectedData) / total

                if (percent > 0)
                    return _.round(percent, 2) + '%'
                else
                    return _.round(percent, 2) + '%'
            },
            color: 'white'
        }
    }
}
